import { Flex, Label, Text, SkeletonText } from '@buffer-mono/popcorn'
import { useAccount } from '~publish/contexts/AccountContext'
import style from '../Settings.module.css'

const CreatedAt = (): JSX.Element => {
  const { account } = useAccount()
  const organizationCreatedAt = account?.currentOrganization?.createdAt
  const formattedDate = organizationCreatedAt
    ? new Date(organizationCreatedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : ''

  return (
    <Flex gap="2xs" direction="column" className={style.fullWidth}>
      <Label>Creation Date</Label>
      {organizationCreatedAt ? (
        <Text
          as="time"
          color="subtle"
          dateTime={formattedDate ? new Date(formattedDate).toISOString() : ''}
        >
          {formattedDate}
        </Text>
      ) : (
        <SkeletonText lines={1} width="100px" />
      )}
    </Flex>
  )
}

export default CreatedAt
